module.exports = require("path");


//////////////////
// WEBPACK FOOTER
// external "path"
// module id = 41
// module chunks = 0